import React from "react";
import assign from "object-assign";

let autoPlay;

function buildSlideList(slides, visible, centerIndex) {
    //Have to have an odd number of slides so it can center
    visible = (2 * Math.ceil(visible / 2)) - 1;
    //Add an ID to each slide so we can know its original position
    slides = slides.map((slide, index) => assign({id: index}, slide));
    //shift array so it begins with centerIndex slide
    slides = slides.slice(centerIndex, slides.length).concat(slides.slice(0, centerIndex));

    let result = [],
        numSlides = (2 * visible) - 1,
        i = 0,
        l = Math.ceil(numSlides / 2),
        rIndex, lIndex;


    while (i < l) {
        rIndex = i % slides.length;
        lIndex = slides.length - (i % slides.length) - 1;
        result.push(slides[rIndex]);
        result.unshift(slides[lIndex]);
        i += 1;
    }

    //Knock the first element off to balance even-length results
    if (result.length % 2 === 0) {
        result.shift();
    }

    return result;
}

let PressCarousel = React.createClass({
    getInitialState() {
        return this.resetState(0);
    },
    propTypes: {
        data: React.PropTypes.array.isRequired,
        visibleSlides: React.PropTypes.number,
        autoPlay: React.PropTypes.number
    },
    resetState(id) {
        return {
            newIndex: null,
            moveClass: "",
            slides: buildSlideList(this.props.data, this.props.visibleSlides || 1, id)
        };
    },
    centerOn(i, id) {

        if (this.state.newIndex) {
            return;
        }

        if (this.props.autoPlay) {
            clearInterval(autoPlay);
        }

        let centerIndex = Math.ceil(this.state.slides.length / 2) - 1,
            direction = i > centerIndex ? "left" : "right",
            distance = Math.abs(i - centerIndex),
            moveClass = `${direction}-${distance}`;

        this.setState({
            moveClass,
            newIndex: i
        });

        setTimeout(() => {
            this.setState(this.resetState(id));
            if (this.props.autoPlay) {
                autoPlay = setInterval(() => {
                    let nextIndex = Math.ceil(this.state.slides.length / 2);

                    this.centerOn(5, this.state.slides[nextIndex].id);
                }, this.props.autoPlay);
            }
        }, 1500); //this number must exceed the transition duration for .eo-carousel-press-slide in PressCarousel.css
    },
    componentDidMount(){
        if (this.props.autoPlay) {
            autoPlay = setInterval(() => {
                let nextIndex = Math.ceil(this.state.slides.length / 2);

                this.centerOn(5, this.state.slides[nextIndex].id);
            }, this.props.autoPlay);
        }
    },
    componentWillUnmount(){
        if (this.props.autoPlay) {
            clearInterval(autoPlay);
        }
    },
    render() {
        let centerIndex = Math.ceil(this.state.slides.length / 2) - 1;

        return (
            <section className="eo-carousel-press grid-10 no-gutter">
                <div className="eo-carousel-press-quotes grid-parent eo-info gray">
                    <a target="_blank" href={this.state.slides[centerIndex].link} className={["eo-carousel-press-blurb new", (this.state.newIndex ? "fade-out" : "show-blurb")].join(" ")}>
                        <h2>
                            {`"${this.state.slides[centerIndex].quote}"`}
                        </h2>

                        <div className={["eo-carousel-press-source"].join(" ")}>
                            <p className="eo-carousel-press-name">{this.state.slides[centerIndex].name}</p>

                            {/* <p className="eo-carousel-press-company">{this.state.slides[centerIndex].company}</p> */}
                        </div>
                    </a>
                    <a target="_blank" href={this.state.slides[this.state.newIndex || centerIndex].link} className={["eo-carousel-press-blurb", (this.state.newIndex ? "fade-in" : "hide-blurb")].join(" ")}>
                        <h2>{`"${this.state.slides[this.state.newIndex || centerIndex].quote}"`}</h2>

                        <div className={["eo-carousel-press-source"].join(" ")}>
                            <p className="eo-carousel-press-name">{this.state.slides[this.state.newIndex || centerIndex].name}</p>

                            {/* <p className="eo-carousel-press-company">{this.state.slides[this.state.newIndex || centerIndex].company}</p> */}
                        </div>
                    </a>
                </div>
                <div
                    className={["eo-carousel-press-slide-container", this.state.moveClass, this.state.newIndex ? "animate" : ""].join(" ")}>
                    {this.state.slides.map((blurb, index) => {
                        let isCurrent = this.state.newIndex === index || !this.state.newIndex && index === centerIndex;

                        return (
                            <div style={{ color: isCurrent ? blurb.color : "rgba(0,0,0,0.5)" }} key={index}
                                 onClick={this.centerOn.bind(this, index, blurb.id)}
                                 className={["eo-carousel-press-slide", "icon", `slide-${index}`, (isCurrent ? "active" : null )].join(" ")}>
                                <h3 className={["eo-carousel-press-slide-logo", blurb.logo].join(" ")}></h3>
                            </div>
                        );
                    })}
                </div>
            </section>
        );
    }
});

export default PressCarousel;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/root/components/PressCarousel.js
 **/